export default __webpack_public_path__ + "static/media/confirmModal.8bf3630e.svg";